import { IConfig as UnleashConfig } from 'unleash-proxy-client';

export const UNLEASH_URL =
  'https://us.app.unleash-hosted.com/usee0016/api/frontend';

export const UNLEASH_REFERESH_TIMEOUT = 60;

export const RD_UNLEASH_CONFIG: Pick<
  UnleashConfig,
  'context' | 'url' | 'refreshInterval'
> = {
  url: UNLEASH_URL,
  refreshInterval: UNLEASH_REFERESH_TIMEOUT,
  context: {
    userId: 'logoutUser',
  },
};
